import React from 'react';
import Clock from 'react-live-clock';
//import mapImage from '../images/map.png';
import logoImage from '../images/customer_logo.png';
import './Menu.css';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { setPlaying, clearChapterActionsThunk, toggleInfoPopupThunk, toggleWeatherThunk, changeStoryAction } from '../store/StoryStore';

const Menu = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    // Kun id'et på kopi-historien (eller undefined) hentes, så menuen ikke re-renderer ved hver datahentning
    const copyStoryId = useSelector(state => {
        const stories = state.storyState.stories;
        const copyStory = stories.length > 1 ? stories.find(s => (s.name || '').includes('kopi')) : undefined;
        return copyStory ? copyStory.id : undefined;
    });

    // Et klik på uret skifter til historien med "kopi" i navnet (hvis den findes)
    const changeToCopyStory = () => {
        if (copyStoryId !== undefined) {
            dispatch(setPlaying(false));
            dispatch(clearChapterActionsThunk());
            dispatch(toggleInfoPopupThunk(undefined, false));
            dispatch(toggleWeatherThunk(false));
            dispatch(changeStoryAction({ storyId: copyStoryId }));
            navigate('/');
        }
    };
    // Kun værker med en kort sikkerhedsintroduktion må navigere til den
    const hasShortStory = useSelector(state =>
        state.storyState.stories.some(s => s.category === 'Kort sikkerhedsintroduktion' && s.chapters && s.chapters.length > 0)
    );

    return (
        <div className="menu">
            <div className='clock-container' onClick={changeToCopyStory}>
                <Clock format={'HH:mm'} ticking={true} timezone={'Europe/Copenhagen'} interval={30000} />
            </div>
            <div className="menu-point-container">
                <div className="menu-point">
                    <div onClick={() => navigate('/')}>
                        <img src={require('../images/safety.png')} alt='Hjem menu' />
                    </div>
                </div>
                {/* <div className="menu-point">
                    <div onClick={() => navigate('/extrainteractivestory')}>
                        <img src={require('../images/tænk_miljø_helt_hvid.png')} alt='Poster menu' />
                    </div>
                </div> */}
                <div className="menu-point">
                    <div onClick={() => navigate('/documents')}>
                        <img src={require('../images/dokument_ikon.png')} alt='Arkiv menu' />
                    </div>
                </div>
                <div className="menu-point">
                    <div onClick={() => navigate('/instructions')}>
                        <img src={require('../images/instruktions_video_mappe_ikon.png')} alt='Video arkiv menu' />
                    </div>
                </div>
                {/* 
                <div className="menu-point" onClick={() => navigate('/map')}>
                    <img src={mapImage} alt='Map menu' />
                </div>
                */}
                <div onClick={() => hasShortStory && navigate('/shortinteractivestory')}>
                    <img style={{ position: 'absolute', bottom: 0, left: 0, opacity: 1 }} src={logoImage} alt='' />
                </div>
            </div>

        </div>
    );
};

export default Menu;